/**
* Full Page Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Full Page Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'full-page-left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        $( '.full-page-left-right' ).each( function( key, val ) {
          const image = $( val ).find( '.fit-image img' )[0];

          function resolveAfter1Second() {
            return new Promise( ( resolve ) => {
              setTimeout( () => {
                resolve( 'resolved' );
              }, 2000 );
            } );
          }

          async function asyncCall() {
            await resolveAfter1Second();

            // if the loader is not hidden don't add parallax to avoid issues if takes longer than expected to load
            if ( $( '.eapps-twitter-feed-posts-show-more' ).length > 0 ) {
              ScrollTrigger.refresh();
            } else {
              const allTriggers = ScrollTrigger.getAll();
              allTriggers.forEach( ( trigger ) => {
                trigger.disable();
              } );
            }
          }
          // delay to refresh ScrollTrigger animations postion
          // if twitter plugin is on the page
          // to prevent timing issues
          if ( $( '.twitter-feed' ).length > 0 ) {
            asyncCall();
            // add event listener for the show button
            $( document ).on( 'click', function( event ) {
              if ( $( event.target ).hasClass( 'eapps-twitter-feed-posts-show-more' ) ) {
                asyncCall();
              }
            } );
          }

          if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
            gsap.to( image, {
              y: +200,
              scrollTrigger: {
                trigger: $( val ),
                start: 'top top+=90px',
                end: 'bottom 0%',
                scrub: true,
              },
            } );
          }
        } );
      }
    },
    finalize: function() {

    },
  };

  // Hooks the component into the app
  app.registerComponent( 'full-page-left-right', COMPONENT );
} )( app );
